import toMap from '~/misc/toMap';

export default toMap([
  'SAVE_LOADS',
  'HIDE_LOADS',
  'CHECK_DIALOG',
  'UPDATE_MYLOADS',
  'UPDATE_STATUS',
  'SAVE_BROKER',
  'NO_SAVE_BROKER',
  "DELETE_BOOKING_LOADS"
]);



// WEBPACK FOOTER //
// ./src/modules/myLoads/types.js